import script from "./NoisePattern.vue?vue&type=script&setup=true&lang=js"
export * from "./NoisePattern.vue?vue&type=script&setup=true&lang=js"

import "./NoisePattern.vue?vue&type=style&index=0&id=3e73128f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e73128f"]])

export default __exports__